import http from "./httpService";

export function getSoftSetting() {
  return http.get(`/PublicApi/SoftSetting`).then(({ data }) => data.data);
}
export function getSoftSettingLogo() {
  return http
    .get(`/PublicApi/SoftSetting`)
    .then(({ data }) => data?.data?.mainLogo);
}
